export default __webpack_public_path__ + "static/media/p21.9b606936.JPG";